import type { GoalAttachedGoalResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export const formatAttachedGoals = (
	attachedToGoals: GoalAttachedGoalResponseDTO[],
	formatGoal: (name: string, percent: number) => string,
): string =>
	attachedToGoals
		.map((attached) => formatGoal(attached.name ?? "", attached.usagePercent))
		.join(", ");
